import TicketHttp from "../../ticketHttp";

class TheatreServicesV2 {
  static getTheatres(params = {}) { return TicketHttp.get('/theatres', params); }
}

export default TheatreServicesV2;
